import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";
import { Name } from "../../../../../../../Wrap/Models/Domains/Personal/Name";

interface ICorrespondenceAddressOwnerProps extends React.Props<CorrespondenceAddressOwner> {
    disabled: boolean;
    name: Name;
    onChange: (v: Name) => void;
    onRef: (v) => void;
}
interface ICorrespondenceAddressOwnerState {}

export class CorrespondenceAddressOwner extends FormComponent<
    ICorrespondenceAddressOwnerProps,
    ICorrespondenceAddressOwnerState
> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    public render(): JSX.Element {
        const { name } = this.props;
        return (
            <>
                {SectionHeader("Correspondence Address")}
                <SelectEditor
                    options={TitleMap.getArray()}
                    selected={name ? TitleMap.getEnum(name.Title) : Title.Mr}
                    label="Title"
                    disabled={this.props.disabled}
                    getText={(v) => TitleMap.getString(v)}
                    placeholder={"Please select"}
                    onChange={(v) => this.onChange({ Title: TitleMap.getString(v) })}
                />
                <TextBoxEditor
                    label="Firstname"
                    value={name?.Given}
                    disabled={this.props.disabled}
                    onChange={(v) => this.onChange({ Given: v })}
                />
                <TextBoxEditor
                    label="Surname"
                    value={name?.Family}
                    disabled={this.props.disabled}
                    onChange={(v) => this.onChange({ Family: v })}
                />
            </>
        );
    }

    private onChange(changes: Name) {
        let { name } = this.props;
        if (!name) {
            name = { Title: TitleMap.getString(Title.Mr), Family: null, Given: null };
        }
        for (const key in changes) {
            name[key] = changes[key];
        }
        this.props.onChange(JSON.parse(JSON.stringify(name)));
    }
}
